import React from 'react';

interface ToggleRowProps {
  label: string;
  description: string;
  checked: boolean;
  onChange: (_value: boolean) => void;
  disabled?: boolean;
}

export function ToggleRow({ label, description, checked, onChange, disabled }: ToggleRowProps) {
  return (
    <div className="settings-toggle-row">
      <div className="settings-toggle-row__body">
        <div className="settings-toggle-row__label">{label}</div>
        <div className="settings-toggle-row__desc">{description}</div>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        className={`settings-toggle${checked ? ' settings-toggle--on' : ''}`}
        onClick={() => onChange(!checked)}
        aria-label={label}
      >
        <span className="settings-toggle__thumb" />
      </button>
    </div>
  );
}
